import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import CrmIntegradoHubspot from "@/pages/CrmIntegradoHubspot";

export const Route = createFileRoute("/crm-integrado-hubspot")({
  head: () => buildHead({
    title: "HubSpot integrado ao WhatsApp com Agentes de IA | OP2P",
    description: "Conecte o HubSpot à OP2P: leads e negócios atendidos por Agentes de IA no WhatsApp e Instagram, com o histórico das conversas registrado.",
    path: "/crm-integrado-hubspot",
  }),
  component: CrmIntegradoHubspot,
});
